import './App.css';
import React, { useState, useEffect } from 'react';
import Header from './Pages/Header/Header';
import PaymentGateway from './Pages/PaymentGateway/PaymentGateway';
import DebitCradPaymentProcess from './Pages/PaymentMode/Components/CommonDetails/DebitCradPaymentProcess';
import PaymentSuccess from './Pages/PaymentMode/Components/PaymentSuccess';
import { initializeGTM, redirectWithAnalytics, ANALYTICS_EVENTS } from './Utility/analyticsConfig';

function App() {
const [apiData, setApiData] = useState(null);
const [isLoading, setIsLoading] = useState(true);
const [isEmandate, setIsEmandate] = useState(false);
const [isHealthCheck, setIsHealthCheck] = useState(false);

useEffect(() => {
  initializeGTM();
}, []);

let ismandate = false;
 useEffect(() => {
 const pathname = window.location.pathname; 
 const queryParameters = new URLSearchParams(window.location.search);
 let fetchData;
 
  if (pathname === '/initiateEmandate') {
   setIsLoading(false);
   ismandate = true;
   setIsEmandate(true);
  }

 	
   if (pathname === '/healthStatus') {
      setIsHealthCheck(true);
      setIsLoading(false); 
      return;
    }
    
 if(!ismandate){
   fetchData = async () => {
    try {
      const order = queryParameters.get("orderNo");
      const var1 = queryParameters.get("var1");
      const var2 = queryParameters.get("var2");
      const temp = { orderNo: order };

      const response = await fetch(`/pay/securePayment/details/getSessionTime?var1=${var1}&var2=${var2}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(temp),
      });

      const data = await response.json();
     
      if(data.rurl){
       redirectWithAnalytics(data.rurl, ANALYTICS_EVENTS.REDIRECT_SERVER_RURL, {
        redirectType:'server-rurl',
        apiEndpoint: '/pay/securePayment/details/getSessionTime',
        responseData: data,
        reason: 'rurl present in response',
        sourceOfError: '/pay/securePayment/details/getSessionTime'
       }
        );
      }else{
      setApiData(data);
      setIsLoading(false);
      }
    
    } catch (error) {
      console.error('API request error:', error);
      
      redirectWithAnalytics(
        "https://www.policybazaar.com", 
        ANALYTICS_EVENTS.REDIRECT_API_ERROR,
        {
          errorMessage: error.message,
          errorStack: error.stack,
          apiEndpoint: '/pay/securePayment/details/getSessionTime',
          reason: 'API request failed',
          sourceOfError: '/pay/securePayment/details/getSessionTime'
        }
      );
    }
  };
  }
  
  if (apiData === null && !ismandate) {
    fetchData();
  }
}, [apiData]); 



  return (
    <>
      {isHealthCheck ? (
        <div>OK</div>  // Display "OK" if it's the health check endpoint
      ) : (
        <>
          {!isLoading && <Header apiData={apiData} />}
          <div className='wrapper'>
            {!isLoading && <PaymentGateway apiData={apiData} />}
          </div>
        </>
      )}

    </>
  );
}

export default App;
